import React from 'react';
import { STATS } from '../data/mock';

const Stats = () => {
  return (
    <section className="py-14 md:py-20 bg-white border-y border-pink-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-6">
          {STATS.map((s, i) => (
            <div
              key={s.label}
              className="text-center"
              style={{ animationDelay: `${i * 60}ms` }}
              data-testid={`stat-${s.label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
            >
              <div className="font-display font-black text-4xl md:text-5xl text-pink-brand leading-none">{s.value}</div>
              <div className="mt-2 text-xs md:text-sm text-stone-500 uppercase tracking-wider">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
